import { useContext, useState } from 'react'
import {
    StyleButtonWrapper,
    StyledActionGroup,
    StyledDeleteAccount,
} from './DeleteAccount.styled'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import React from 'react'
import { TNLink } from '../components/TNLink'
import { TNButton } from '../components/TNButton'
import { tokens } from '@news-mono/design-tokens'
import { AppState, ConfigurationContext } from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { useForgotPassword } from '../hooks/useChangePassword'
import { useDeleteAccount } from '../hooks/useDeleteAccount'
import { isEmpty } from 'lodash'
import { TNInput } from '../components/TNInput'
import {
    DeleteAccountClickProps,
    onDeleteAccountClick,
    onForgotPasswordClick,
} from './helpers/delete-account-click-helper'

const { utility } = tokens.thenightly.colors.palette
export const DeleteAccountPassword = () => {
    const [password, setPassword] = useState<string>()
    const [submitting, setSubmitting] = useState<boolean>(false)

    const config = useContext(ConfigurationContext)
    const myAccountContext = useContext(MyAccountContext)

    const { setScreen, setScreenSelected } = myAccountContext

    const { userEmail, wanUserId } = useSelector(
        (state: AppState) => state.authentication,
    )

    const { mutateAsync: sendForgotPasswordEmail } = useForgotPassword({
        email: userEmail!,
    })
    const { mutateAsync: deleteAccount } = useDeleteAccount({
        userId: wanUserId,
        currentPassword: password!,
        email: userEmail!,
        passEncryptionKey: config.passEncryptionKey!,
    })

    const deleteAccountProps: DeleteAccountClickProps = {
        myAccountContext,
        configContext: config,
        mutateProps: {
            onDeleteAccount: deleteAccount,
            sendForgotPasswordEmail,
        },
        passwordState: {
            passwordText: password,
        },
    }

    return (
        <StyledDeleteAccount>
            <TNInput
                id="current-password"
                label="Enter Password"
                type="password"
                onChange={(value) => setPassword(value)}
            />
            <TNLink
                onClick={async () => {
                    setSubmitting(true)
                    await onForgotPasswordClick(deleteAccountProps)
                    setSubmitting(false)
                }}
                color={''}
            >
                Forgot your password?
            </TNLink>
            <StyledActionGroup>
                <TNLink
                    color={utility.error.default}
                    onClick={async () => {
                        setSubmitting(true)
                        await onDeleteAccountClick(deleteAccountProps)
                        setSubmitting(false)
                    }}
                    disabled={isEmpty(password) || submitting}
                    fontWeight={600}
                    underline={false}
                >
                    DELETE MY ACCOUNT
                </TNLink>
                <StyleButtonWrapper>
                    <TNButton
                        onClick={() => {
                            setScreen('manage-account')
                            setScreenSelected(true)
                        }}
                        btnType="primary"
                        disabled={submitting}
                    >
                        CANCEL
                    </TNButton>
                </StyleButtonWrapper>
            </StyledActionGroup>
        </StyledDeleteAccount>
    )
}
